import { apiSlice } from '../app/api/apiSlice';

export const leadApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    signupBfEarly: builder.mutation({
      query: ({ firstName, email }) => ({
        url: 'leads/bf-early',
        method: 'POST',
        body: { firstName, email },
      }),
    }),
  }),
});

export const { useSignupBfEarlyMutation } = leadApiSlice;
